<template>
  <div>
    <gs-modal v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm" :title="title"
      :has-form="true" class="time-event-dialog-modal" top="15%" width="36%" @close="close" @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form :model="form" label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="description">
              </el-input>
            </gs-form-item>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="时间规划" name="second">
          <gs-checkbox-group v-model="checkedCities">
            <gs-checkbox v-for="city in cities" :label="city" :key="city" style="margin:10px">{{ city
              }}</gs-checkbox>
          </gs-checkbox-group>
          <el-table size='mini' :data="timeChartList"
            :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }"
            style="width: 100%;margin-top:15px">
            <el-table-column prop="startTime" label="开始时间" align="center">
            </el-table-column>
            <el-table-column prop="stopTime" label="结束时间" align="center">
            </el-table-column>
          </el-table>
        </gs-tab-pane>
        <gs-tab-pane label="联动数据" name="last">
          <el-table :data="objectSeries" size="mini"
            :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #4e4c4c' }"
            style="width: 100%" height="220">
            <el-table-column prop="name" label="名称" align="center">
            </el-table-column>
            <el-table-column label="开始值" align="center" prop="startnum">
            </el-table-column>
            <el-table-column label="结束值" align="center" prop="stopnum">
            </el-table-column>
          </el-table>
        </gs-tab-pane>
      </gs-tabs>
    </gs-modal>
  </div>
</template>

<script>

export default {
  data() {
    return {
      visible: false,
      title: '时间表',
      activeName: 'first',
      form: {

      },
      name: '',
      description: '',
      objectSeries: [],
      checkedCities: ['星期一', '星期二', '星期三', '星期四', '星期五'],
      cities: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      timeChartList: [],
    };
  },

  components: {},

  computed: {},

  beforeMount() { },

  mounted() { },

  methods: {
    beforeClose() {
      this.visible = false
    },
    beforeConfirm() {
      this.visible = false
    },
    handleConfirm() {
      this.visible = false
    },
    close() {
      this.visible = false
    },
    kongShow(val) {
      this.activeName = 'first'
      this.title = `${val}层开放办公区空调时间表`
      this.description = `中午12:31到13:29`
      this.timeChartList = [
        {
          startTime: '12:31',
          stopTime: '13:29'
        },
      ]
      this.objectSeries = [
        {
          name: 'BW_FANS_ON',
          startnum: '1',
          stopnum: '0'
        },
      ]
      if (val == '5') {
        this.name = `五层开放午休空调开启时间表`
      }
      if (val == '4') {
        this.name = `四层开放午休空调开启时间表`
      }
      if (val == '3') {
        this.name = `三层开放午休空调开启时间表`
      }
      if (val == '2') {
        this.name = `二层开放午休空调开启时间表`
      }
      if (val == '1') {
        this.name = `一层开放午休空调开启时间表`
      }

      this.visible = true
    },
    dengShow(val) {
      this.activeName = 'first'
      this.title = `${val}层开放办公区照明时间表`
      this.timeChartList = [
        {
          startTime: '12:30',
          stopTime: '13:30'
        },
      ]
      this.objectSeries = [
        {
          name: 'DOW_PHY_NO',
          startnum: '0',
          stopnum: '1'
        },
      ]
      if (val == '5') {
        this.name = `五层开放午休照明时间表`
        this.description = `中午12.30-13.30`
      }
      if (val == '4') {
        this.name = `四层开放午休照明时间表`
        this.description = `中午12.30-13.30`
      }
      if (val == '3') {
        this.name = `三层开放午休照明时间表`
        this.description = `中午12.30-13.30`
      }
      if (val == '2') {
        this.name = `二层开放午休照明时间表`
        this.description = `中午12.30-13.30`
      }
      if (val == '1') {
        this.name = `一层开放午休照明时间表`
        this.description = `中午12.30-13.30`
      }

      this.visible = true
    }
  },

  watch: {}

}

</script>
<style lang='' scoped>

</style>


// WEBPACK FOOTER //
// src/components/graphically/nari/timeChare.vue